define((require) => {
    "use strict";

    const $        = require("jquery");
    const Lightbox = require("shared/ui/common/Lightbox");
    const Icons    = require("shared/ui/assets/Icons");

    /**
     * Lightbox class used in the viewer only.
     */
    return Lightbox.extend({

        /**
         * We want the lightbox to be vertically centered at all times (in viewer context).
         *
         * @type {String}
         * @see  Lightbox#defaultPosition
         */
        defaultPosition: "fixed",

        /**
         * Close button shown on top of the top-right corner of the lightbox.
         * @returns {*|String}
         */
        createCloseButton() {
            return Icons.CLOSE.createElement().css({
                position: "absolute",
                top: -14,
                right: -14,
                width: 28,
                height: 28,
                cursor: "pointer",
                zIndex: 1000
            });
        },

        /**
         * Creates the root element for the lightbox. It ensures has a white background
         * TODO Kept to not break functionality, but needs to be checked!
         * @returns {*|String|jQuery}
         */
        createRootElement(lightboxClassName) {
            const $zmagsLightbox = $("<div class='zmags-lightbox-viewer'></div>").css({
                backgroundColor: "#FFF"
            });

            if (lightboxClassName) {
                $zmagsLightbox.addClass(lightboxClassName);
            }

            return $zmagsLightbox;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/lightbox/ViewerLightbox.js